// extracted by mini-css-extract-plugin
export var editInput = "_i8-0";
export var editInputCompact = "_i8-2";
export var editInputLarge = "_i8-1";
export var editInputSmall = "_i8-3";